const DateLocale = (date, hours) => {
  return new Date(new Date(date).setHours(date.getHours() + hours));
};

export default DateLocale;
